<label class="c-controlled-textarea {{classList}}">
	<div class="c-controlled-textarea_info">
		<span class="c-controlled-textarea_info_label">
			{{labelText}}
			{{#if @this.partials.labelIcon && !hideLabelIcon}}
				{{>labelIcon}}
			{{/if}}
		</span>

		{{#if error}}
			<span class="c-controlled-textarea_info_errorMsg">
				{{error}}
			</span>

			<img class="c-controlled-textarea_err-icon"
				width="20"
				height="20"
				src="{{@shared.assetsHost}}/img/alert-icon.svg">
		{{/if}}
	</div>

	<textarea
		{{#if id}}id="{{id}}"{{/if}}
		rows="{{taRowsAmount}}"
		value="{{taValue}}"
		placeholder="{{placeholder}}"
		class="{{#if error}}has-error{{/if}}{{#if disabled}}is-disabled{{/if}}"
		disabled="{{disabled}}">
	</textarea>
</label>

<script>
	const listeners = require('../../assets/js/utils/listeners');
	const DEFAULT_TEXTAREA_ROWS_AMOUNT = 2;

	component.exports = {
		data () {
			return {
				invalidValue: null,
				errMsgTopPos: false,
				taRowsAmount: DEFAULT_TEXTAREA_ROWS_AMOUNT,
				taValue: null,
			};
		},
		oninit () {
			if (!Ractive.isServer) {
				this.observeOnce('error', () => {
					this.set('invalidValue', this.get('value'));
				}, { init: false });

				this.observe('value', (value) => {
					let invalidValue = this.get('invalidValue');
					let error = this.get('error');

					if (error && invalidValue !== value) {
						this.set('error', undefined);
					}
				});

				this.observe('screenWidth', (screenWidth) => {
					if ((screenWidth || window.innerWidth) < 768) {
						this.set('errMsgTopPos', true);
					} else {
						this.set('errMsgTopPos', false);
					}
				});

				// parse passed textarea value (expected input { <any-key>: string }) to taValue
				this.observe('value', (value) => {
					let currTaElCnt = (this.get('taValue') || '').split(/(\r\n|\n|\r)/).filter(Boolean);

					if (value && Object.keys(value) && currTaElCnt < Object.keys(value).length) {
						let taValue = Object.keys(value).reduce((str, key) => {
							return str += `${key}: ${value[key]}\n`;
						}, '');

						this.set('taValue', taValue);
					}
				});

				// handle Textarea rows value based on the content
				this.observe('taValue', (taValue = '') => {
					if (taValue === null) { return; }

					let taRowsAmount = DEFAULT_TEXTAREA_ROWS_AMOUNT;
					let newLines = taValue.match(/(\r\n|\n|\r)/g);

					if (newLines && newLines.length + 1 >= DEFAULT_TEXTAREA_ROWS_AMOUNT) {
						taRowsAmount = newLines.length + 2;
					}

					this.set('taRowsAmount', taRowsAmount);
				});

				// parse Textarea taValue and set value
				this.observe('taValue', (taValue = '') => {
					if (taValue === null) { return; }

					let rows = taValue.split(/(\r\n|\n|\r)/).filter(Boolean);
					let parsedHeaders = rows.reduce((res, row) => {
						let keyValueRegex = /^([^:]+):(.+)$/;
						let match = row.trim().match(keyValueRegex);

						if (match) {
							let key = match[1].trim();
							let value = match[2].trim();

							if (key && value) {
								res[key] = value;
							}
						}

						return res;
					}, {});

					this.set('value', parsedHeaders);
				});
			}
		},
		onrender () {
			listeners.screenWidthListener(this);
		},
	};
</script>
